import Emitter from "./Emitter";

export default class Resize extends Emitter {
    constructor(gb) {
        super(gb);
    }

    _default(sizeObj) {

        let passObj = {};
        if (sizeObj.height) {
            passObj.height = sizeObj.height;
        }
        if (sizeObj.width) {
            passObj.width = sizeObj.width;
        }

        if (sizeObj.value) {
            passObj.height = sizeObj.value;
        }

        this.emitTop({ wpgaction: "resize", data: passObj });
        this.emitParent({ wpgaction: "resize.parent", data: passObj });
        this.emitiOS({ wpgaction: "resize", data: passObj });
    }
}
